( function ( $ ) {
	
	$( document ).ready( function() {
		
		$( document ).foundation();
		new WOW().init();		

	} );
	
	/* http://blog.jonathanargentiero.com/foundation-interchange-lazy-loading/ */
	$.fn.lazyInterchange = function() {
		var selectors = this.each( function() {
			var data_lazy = $( this ).attr( 'data-lazy' );
			if( data_lazy ){
				$( this ).attr( 'data-interchange', data_lazy ).data( 'interchange', data_lazy );
				$( this ).removeAttr( 'data-lazy' );
				new Foundation.Interchange( $( this ) );
			}
		} );
		return selectors;
	}
	$( document ).on( 'lazybeforeunveil', function( e ) {
		$( e.target ).lazyInterchange();
	} );
	
	$( '.infinitescroll' ).infiniteScroll( {
		path: ( $( 'body' ).hasClass( 'single' ) ) ? function(){ return $( '.post-navigation:last > .next-post > a' ).attr( 'href' ); } : '.posts-pagination > .navigation > ul > li.next-post > a',
		append: '.append',
		scrollThreshold: 650,
		history: 'push',
		historyTitle: true,
		hideNav: false,
		debug: false
	} );
	
} )( jQuery );
